<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="alarmSubscribe">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 告警订阅关系
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="设备名称">
                <el-input placeholder="请输入设备名称" v-model="seefrom.deviceName"></el-input>
              </el-form-item>
              <el-form-item label="设备编码">
                <el-input placeholder="请输入设备编码" v-model="seefrom.deviceMark"></el-input>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <el-table :data="tableData" style="width: 100%" class="stripeTable" height="500" ref="Table">
            <el-table-column show-overflow-tooltip :label="label" :prop="prop" :align="align" v-for="({prop,label,align, width}) in config" :key="prop.toString()" :width="width"></el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <el-link icon="iconfont iconedit" type="text" size="small" @click="toEdit(scope.row)">编辑</el-link>
                <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteDevice(scope.row)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination layout="prev, pager, next" :page-size="10" @current-change="handleCurrentChange" :total="nTotal" :current-page="currentPage"></el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog class="editDialog" :visible.sync="editDialog" title="编辑" :close-on-click-modal="false" @close="closeDialog">
      <el-form ref="editForm" :model="editForm" :rules="rules">
        <el-form-item label="实时推送地址" prop="sendUrl">
          <el-input placeholder="请输入实时推送地址" v-model="editForm.sendUrl" class="detail_input"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancelButton" @click="close">取 消</el-button>
        <el-button class="confirmButton" type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ifSuccess: false,
      addDisplayForm: false,
      tabName: 'alarmSubscribe',
      loading: true,
      form_jsgl: {},
      showTable: true,
      //搜索表单
      seefrom: {
        deviceName: '',
        deviceMark: '',
        companyId: localStorage.getItem('companyId')
      },
      items: [],
      editForm: {
        sendUrl: '',
        id: ''
      },
      rules: {
        sendUrl: [
          { required: true, message: '请输入实时推送地址', trigger: 'blur' }
        ]
      },
      editDialog: false,
      tableData: [],
      nTotal: 0,
      currentPage: 0
    }
  },
  computed: {
    self() {
      return this
    },
    config() {
      return [
        {
          prop: 'deviceName',
          label: '设备名称'
        },
        {
          prop: 'deviceMark',
          label: '设备编码'
        },
        {
          prop: 'deviceType',
          label: '设备类型'
        },
        {
          prop: 'subscribeIp',
          label: '订阅ip'
        },
        {
          prop: 'sendUrl',
          label: '实时推送地址'
        },
        {
          prop: 'subscribeTimes',
          label: '订阅时间',
          width: 160
        },
        {
          prop: 'firstSendTime',
          label: '首次发送时间',
          width: 160
        },
        {
          prop: 'latestSendTime',
          label: '最近发送时间',
          width: 160
        },
        {
          prop: 'sendFailureCount',
          label: '发送失败数量',
          width: 120
        },
        {
          prop: 'sendSuccessCount',
          label: '发送成功数量',
          width: 120
        }
      ]
    }
  },
  components: {
    normalNav: () => import('public/normalNav'),
    searchForm: () => import('public/searchForm'),
    easyTable: () => import('public/easyTable')
  },
  methods: {
    //搜索
    subSeefrom() {
      this.currentPage = 1
      this.getTableData()
    },
    //重置
    reset() {
      this.seefrom.deviceName = ''
      this.seefrom.deviceMark = ''
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getTableData()
    },
    getTableData() {
      this.$axiosget('manager/subscribeRelation/page', {
        params: {
          pageSize: 10,
          pageNum: this.currentPage,
          ...this.seefrom
        }
      }).then((res) => {
        if (res.data.data.list != null) {
          this.tableData = res.data.data.list.map((item) => {
            return {
              ...item,
              subscribeTimes: item.subscribeTime
                ? item.subscribeTime.replace(
                    /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/g,
                    '$1-$2-$3 $4:$5:$6'
                  )
                : ''
            }
          })
        } else {
          this.tableData = []
        }
        this.nTotal = res.data.data.total
      })
    },
    closeDialog() {
      this.$nextTick(() => {
        this.$refs.editForm.resetFields()
      })
    },
    close() {
      this.editDialog = false
      this.closeDialog()
    },
    toEdit(row) {
      let data = row
      this.editForm = data
      this.editDialog = true
    },
    submitForm() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$axiospost('manager/subscribeRelation/update', {
            ...this.editForm
          }).then((res) => {
            if (res.data.status == 10000) {
              this.$message.success('修改成功')
              this.close()
              this.getTableData()
            }
          })
        }
      })
    },
    //删除
    deleteDevice(row) {
      this.$confirm('是否删除该设备的告警订阅关系？', '删除操作', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.$axiosdelete('manager/subscribeRelation/delete', {
          params: {
            id: row.id
          }
        }).then((res) => {
          if (res.data.status == 10000) {
            this.$message.success('删除成功!')
          }
          this.subSeefrom()
        })
      })
    }
  },
  mounted() {
    this.getTableData()
  }
}
</script>

<style lang="less" scoped>
.content {
  .w_normalNav {
    padding-top: 10px;
    height: 52px;
    position: absolute;
    top: -52px;
    right: 32px;
    // z-index: 99;
  }
  .el-input__inner:focus {
    border: 1px solid #3587c7;
  }
  .el-table__body tr.current-row > td {
    background-color: #234366;
  }
  .el-table tr {
    background-color: #2d374d;
  }
  .el-table th {
    background-color: #2d374d;
  }
  .el-table td {
    background-color: #2d374d;
  }

  .el-table td {
    background-color: #2d374d;
  }
  .cell {
    color: #f2f8fe;
  }
}

.editDialog .el-dialog {
  width: 600px;
}

.dialog-footer {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute4/dataAnalysis/deviceData/alarmSubscribe.vue